module.exports = __webpack_public_path__ + "img/1_006.c4a6ae76.jpg";